import React, { useState } from "react";
import { useBooking } from "../context/bookingContext";
import { useNavigate } from "react-router-dom";
import "./myBookingsPage.css";

export default function MyBookingsPage() {
  const { bookings, cancelBooking } = useBooking();
  const [email, setEmail] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [confirmId, setConfirmId] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  const userBookings = bookings.filter(
    (b) => b.email?.toLowerCase() === email.toLowerCase()
  );

  const handleModify = (booking) => {
    navigate("/booking", { state: booking });
  };

  const askCancel = (id) => setConfirmId(id);
  const doCancel = () => {
    if (confirmId) cancelBooking(confirmId);
    setConfirmId(null);
  };

  return (
    <div className="my-bookings-page">
      <div className="my-bookings-card">
        <h1>My Bookings</h1>
        <p className="sub-text">Enter your confirmation email:</p>
        <form onSubmit={handleSubmit} className="email-form">
          <input
            type="email"
            id="user-email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="view-btn">
            View Bookings
          </button>
        </form>

        {showResults && (
          <div className="results">
            {userBookings.length > 0 ? (
              userBookings.map((b) => (
                <div key={b.id} className="booking-result">
                  <span className="booking-details">
                    {new Date(b.date).toLocaleDateString("en-GB")} - {b.time} -{" "}
                    {b.guests} Guest{b.guests > 1 ? "s" : ""}
                  </span>
                  <div className="booking-actions">
                    <button
                      className="modify-btn"
                      onClick={() => handleModify(b)}
                    >
                      Modify
                    </button>
                    <button
                      className="cancel-btn"
                      onClick={() => askCancel(b.id)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p>No bookings found for {email}.</p>
            )}
          </div>
        )}
      </div>

      {confirmId && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>Are you sure you want to cancel?</p>
            <button className="cta-button" onClick={doCancel}>
              Yes, cancel reservation
            </button>
            <button className="cta-button" onClick={() => setConfirmId(null)}>
              No, keep reservation
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
